import React from 'react';
import { Link } from 'react-router-dom';
import Breadcrumbs from '../components/Breadcrumbs';
import './MapaSitio.css';

const PQRS_EMAIL = 'oficinajuridicadiocesisipiales@gmail.com';

const MapaSitio = () => {
  const secciones = [
    {
      titulo: 'Páginas Principales',
      enlaces: [
        { nombre: 'Inicio', ruta: '/', descripcion: 'Página principal del portal' },
        { nombre: 'Acerca de la Diócesis', ruta: '/acerca', descripcion: 'Información institucional, misión, visión, historia y autoridades' },
        { nombre: 'Noticias', ruta: '/noticias', descripcion: 'Noticias y publicaciones de la Diócesis' },
        { nombre: 'Búsqueda Avanzada', ruta: '/busqueda', descripcion: 'Búsqueda global en todo el contenido del portal' },
        { nombre: 'Contacto', ruta: '/contacto', descripcion: 'Formas de contacto con la Diócesis' },
      ]
    },
    {
      titulo: 'Servicios',
      enlaces: [
        { nombre: 'Galería Multimedia', ruta: '/galeria', descripcion: 'Galería de imágenes y videos institucionales' },
      ]
    },
    {
      titulo: 'Información Legal',
      enlaces: [
        { nombre: 'Política de Privacidad', ruta: '/politica-privacidad', descripcion: 'Política de privacidad del portal' },
        { nombre: 'Tratamiento de Datos Personales', ruta: '/tratamiento-datos', descripcion: 'Política de tratamiento de datos personales' },
        { nombre: 'Mapa del Sitio', ruta: '/mapa-sitio', descripcion: 'Mapa completo del sitio web' },
      ]
    }
  ];

  return (
    <div className="mapa-sitio-page">
      <section className="section">
        <div className="container">
          <h1 className="page-title">Mapa del Sitio</h1>
          
          <div className="mapa-intro">
            <p>
              Este mapa del sitio le permite navegar fácilmente por todas las secciones y páginas 
              disponibles en el portal de la Diócesis de Ipiales.
            </p>
            <p>
              <strong>Última actualización:</strong> {new Date().toLocaleDateString('es-CO')}
            </p>
          </div>

          <div className="mapa-pqrs-info">
            <h2>PQRS (Peticiones, Quejas, Reclamos, Sugerencias y Denuncias)</h2>
            <p>
              Las PQRS se reciben únicamente por correo electrónico. Por ahora el módulo de PQRS 
              en el portal está desactivado. Para enviar una petición, queja, reclamo, sugerencia 
              o denuncia, diríjase al siguiente correo:
            </p>
            <p className="mapa-pqrs-email">
              <a href={`mailto:${PQRS_EMAIL}`}>{PQRS_EMAIL}</a>
            </p>
          </div>

          <div className="mapa-secciones">
            {secciones.map((seccion, index) => (
              <div key={index} className="mapa-seccion">
                <h2>{seccion.titulo}</h2>
                <ul className="mapa-enlaces">
                  {seccion.enlaces.map((enlace, enlaceIndex) => (
                    <li key={enlaceIndex}>
                      <Link to={enlace.ruta}>{enlace.nombre}</Link>
                      <p className="enlace-descripcion">{enlace.descripcion}</p>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          <div className="mapa-enlaces-externos">
            <h2>Enlaces Externos</h2>
            <ul>
              <li><a href="https://www.cec.org.co" target="_blank" rel="noopener noreferrer">Conferencia Episcopal de Colombia</a></li>
              <li><a href="https://www.celam.org" target="_blank" rel="noopener noreferrer">Consejo Episcopal Latinoamericano</a></li>
              <li><a href="https://www.synod.va" target="_blank" rel="noopener noreferrer">Sínodo de la Sinodalidad</a></li>
              <li><a href="https://www.vaticannews.va" target="_blank" rel="noopener noreferrer">Vatican News</a></li>
              <li><a href="https://www.cristovision.tv" target="_blank" rel="noopener noreferrer">Cristovisión</a></li>
            </ul>
          </div>
        </div>
      </section>
    </div>
  );
};

export default MapaSitio;




